export default __webpack_public_path__ + "static/media/wh_ep1_accuse_character__tomo2.883c00a1.jpg";